// extracted by mini-css-extract-plugin
export default {"text":"Mentorship_text__XsNLP","inner":"Mentorship_inner__WV0qD","part":"Mentorship_part__PIvau","heading":"Mentorship_heading__9P8ut","buttons":"Mentorship_buttons__jgSqD"};